
  export const GOALS_RECEIVED = "GOALS_RECEIVED";
  export const SET_GOAL = "SET_GOAL";
  export const CREATE_GOAL = "CREATE_GOAL";
  export const SET_PROPERTY_GOAL = "SET_PROPERTY_GOAL";
  